module.exports = __webpack_public_path__ + "assets/img/dh1.84aec401.jpg";